import { PropsWithChildren } from 'react'
import { tv } from 'tailwind-variants'
import Card from './Card'

const tileStyles = tv({
  slots: {
    base: 'text-base shrink-0',
    header: 'whitespace-nowrap',
  },
  variants: {
    size: {
      small: {
        base: 'py-1 px-3 min-w-16 flex-col whitespace-nowrap items-center text-center',
        header: 'uppercase text-xs opacity-70',
      },
      medium: {
        base: 'py-2 px-4 text-sm',
        header: 'mb-2 pb-1 block border-b font-bold',
      },
    },
  },
})

interface Props {
  title: string
  className?: string
  innerClassName?: string
  dataPresent?: boolean
  size?: keyof typeof tileStyles.variants.size
}

const DashboardTile = ({
  children,
  title,
  className = '',
  innerClassName = '',
  size = 'small',
  dataPresent = true,
}: PropsWithChildren<Props>) => {
  const { base, header } = tileStyles({ size })

  return (
    <Card className={`${base()} ${className}`}>
      <span className={header()}>{title}</span>
      <div
        className={`${innerClassName} duration-300 ${
          dataPresent ? 'opacity-100' : 'opacity-0'
        } transition-opacity`}
      >
        {children}
      </div>
    </Card>
  )
}

export default DashboardTile
